// Shared article-content enrichment for the React article view AND the static
// page generator. Renders data-driven blocks (short answer, visible FAQs) from
// article fields so every article gets the full SEO treatment automatically.
// Pure string functions — no React, importable from node scripts.

const esc = (s) => String(s ?? '')
  .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

// Answer box shown right after the lead paragraph. Skipped when the content
// already carries a hand-written short-answer insight-box.
export function shortAnswerHtml(article) {
  if (!article?.shortAnswer) return '';
  return `\n<div class="insight-box article-short-answer" style="padding: 16px 18px; border-radius: 10px; background: #0F6B7311; border: 1px solid #0F6B7340; margin: 0 0 24px 0; direction: rtl;">
    <strong>پاسخ کوتاه:</strong> ${esc(article.shortAnswer)}
  </div>\n`;
}

// Visible FAQ section rendered from article.faqs ([[q, a], ...]).
// Google requires FAQPage JSON-LD content to be visible on the page —
// without this block the rich result can be ignored.
export function faqSectionHtml(article) {
  const faqs = article?.faqs;
  if (!faqs?.length) return '';
  const items = faqs.map(([q, a]) => `
    <div class="article-faq-item" style="margin-bottom: 18px;">
      <h3 style="font-size: 16px; margin: 0 0 8px; color: #0F2A2E;">${esc(q)}</h3>
      <p style="margin: 0; line-height: 1.9; color: #263238;">${esc(a)}</p>
    </div>`).join('');
  return `\n<section class="article-faqs" style="margin-top: 40px; padding: 24px; background: #F4EFE6; border: 1px solid #E4DDD2; border-radius: 12px; direction: rtl;">
    <h2 style="margin: 0 0 20px; font-size: 20px;">پرسش‌های پرتکرار</h2>${items}
  </section>\n`;
}

// Full enrichment: short-answer box after the lead + FAQ section appended.
export function enrichArticleHtml(article, contentHtml) {
  let html = contentHtml ?? article?.content ?? '';
  const answer = shortAnswerHtml(article);
  if (answer && !html.includes('article-short-answer')) {
    const withAnswer = html.replace(/(<p[^>]*class="lead"[^>]*>[\s\S]*?<\/p>)/, `$1${answer}`);
    html = withAnswer !== html ? withAnswer : answer + html;
  }
  if (!html.includes('article-faqs')) {
    const faqBlock = faqSectionHtml(article);
    if (faqBlock) {
      // Keep FAQs inside the trailing </div> of .article-content when present.
      const closed = html.replace(/<\/div>\s*$/, `${faqBlock}</div>`);
      html = closed !== html ? closed : html + faqBlock;
    }
  }
  return html;
}
